import { styled } from "../../theme";
import { lightenColor } from "../../utils";
import { MediaImage } from "../../types";

export const FakeQuestionContainer = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  min-height: 100%;
  height: 100%;
  /* justify-content: center; */
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    min-height: 100%;
    height: initial;
  }
`;

export const FakeQuestionTitleContainer = styled.div`
  min-height: 10%;
  align-self: flex-start;
  padding-top: 1em;
  .title_level_2 {
    text-transform: uppercase;
    color: ${({ theme }) => theme.color.primary};
    text-align: left;
    padding-left: 2em;
    padding-bottom: 0.2em;
    border-bottom: 0.2em ${({ theme }) => theme.color.primary} solid;
    @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
      padding-left: 1em;
    }
  }
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    min-height: 3em;
    position: relative;
    font-size: 0.9em;
    padding-top: 5em;
    padding-bottom: 2em;
    max-width: 90%;
  }
`;
export const FakeQuestionTextContainer = styled.div`
  width: 100%;
  min-height: 50%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    min-height: 45vh;
    height: initial;
  }
`;

export const FakeQuestionText = styled.div`
  max-width: 50%;
  box-sizing: border-box;
  font-size: 1.6em;
  font-weight: bold;
  text-align: center;
  color: white;
  background-color: ${({ theme }) => theme.color.secondary};
  padding: 1em;
  box-sizing: border-box;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    max-width: 90%;
    margin-bottom: 1em;
  }
`;
export const FakeQuestionAnswerListContainer = styled.ul<{ answerListHeight: number }>`
  box-sizing: border-box;
  padding: 0;
  position: absolute;
  margin: 0;
  top: ${({ answerListHeight }) => `${answerListHeight / -2}px`};
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  list-style: none;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    flex-direction: column;
    position: relative;
    top: inherit;
    align-items: center;
    justify-content: flex-start;
  }
`;
export const FakeQuestionAnswerItemContainer = styled.li<{ color?: string; answersLenght: number }>`
  box-sizing: border-box;
  color: white;
  border-style: solid;
  border-width: 0.3em;
  font-weight: 200;
  border-color: white;
  width: calc(90% / ${({ answersLenght }) => answersLenght});
  border-radius: 0.6em;
  display: flex;
  justify-content: space-around;
  background-color: ${({ theme }) => theme.color.secondary};
  position: relative;
  align-items: center;
  padding: 0.5em;
  min-height: 5em;
  transition: all 0.2s ease-in;
  &:hover {
    cursor: pointer;
    border-color: ${({ color, theme }) => lightenColor(color === undefined ? theme.color.primary : color, 5)};
    background-color: ${() => lightenColor("#FF5C35", 20)};
    box-shadow: 0px 0px 7px 3px rgba(0, 0, 0, 0.2);
  }
  &.checked {
    cursor: pointer;
    border-color: ${({ color, theme }) => lightenColor(color === undefined ? theme.color.primary : color, 5)};
    background-color: ${({ color, theme }) => lightenColor(color === undefined ? theme.color.primary : color, 5)};
    box-shadow: 0px 0px 7px 3px rgba(0, 0, 0, 0.2);
    color: #fafafa;
  }

  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: 80%;
    margin-bottom: 1em;
  }
`;
export const FakeQuestionAnswerContainer = styled.div<{ bg?: MediaImage | string }>`
  background: ${({ bg }) => (bg ? (typeof bg === "string" ? bg : `url("${bg.url}")`) : "none")};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 5%;
  button {
    background-color: white;
    color: ${({ theme }) => theme.color.primary};
    font-size: 1.6em;
  }

  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    flex-direction: column;
    min-height: 50vh;
    align-items: center;
    justify-content: flex-start;
    padding-top: 1em;
    padding-bottom: 1em;
    
  }
`;
